
/**
 * 回复输入框
 * event:      close 关闭输入框
 *             reply 确认输入  参数： {String} 输入框值
 *             toggle 状态切换
 * public fn:  toggleFocus 切换输入框状态
 */
import xss from 'xss';
import Emoji from '@/components/Emoji';

export default {
  name: 'ReplyComment',
  components: {
    Emoji: Emoji
  },
  data: function data() {
    return {
      commentLoading: false, // 回复loading
      blurIndex: 0, // 回复表情插入位置
      commentsTextarea: '', // 回复内容
      showEmoji: false, // emoji选择标志
      showNoFocus: false
    };
  },

  methods: {
    /**
     * 输入框失去焦点
     */
    blurFun: function blurFun(eve) {
      this.blurIndex = eve.target.selectionEnd;
    },

    /**
     * emoji 表情选择
     */
    selectEmoji: function selectEmoji(val) {
      if (this.commentsTextarea && this.commentsTextarea.length + val.length <= 2000 || !this.commentsTextarea) {
        var list = this.commentsTextarea.split('');
        list.splice(this.blurIndex, 0, val);
        this.commentsTextarea = list.join('');
        this.showEmoji = false;
      }
    },

    /**
     * 提交评论回复
     */
    commentSubmit: function commentSubmit() {
      if (!this.commentsTextarea) {
        this.$message.error('回复内容不能为空');
        return;
      }
      this.$emit('reply', xss(this.commentsTextarea));
    },

    /**
     * 关闭评论回复框
     */
    closeComment: function closeComment() {
      this.showEmoji = false;
      this.$emit('close');
      this.toggleFocus();
    },


    /**
     * 切换输入框状态
     */
    toggleFocus: function toggleFocus(flag) {
      if (typeof flag === 'boolean') {
        this.showNoFocus = flag;
      } else {
        this.showNoFocus = !this.showNoFocus;
      }
      this.$emit('toggle', this.showNoFocus);
    }
  }
};